import { PurchaseRequestState } from '../types';

export const titleTexts: Record<PurchaseRequestState, string> = {
  [PurchaseRequestState.Default]:
    'This artwork is not available for sale at the moment, but you can submit a request to purchase it.',
  [PurchaseRequestState.SendRequest]:
    'Please provide your contact information so we can notify you when the artwork becomes available for purchase.',
  [PurchaseRequestState.Success]: '',
};
